
    export default `
        .cnnix__footer
        {
            display: flex !important;
            height: 100%;
            background-color: #0C0C0C;
            color: #E6E6E6;
            font-family: CNN, Helvetica Neue, Helvetica, Arial, Utkal, sans-serif;
            font-size: 10px;

            @media screen and (min-width: 740px) {
                height: 100%;
            }

            a
            {
                color: #E6E6E6;
                transition: all 250ms ease-in-out;

                &:hover
                {
                    color: white;
                }
            }
        }

        .cnnix__footer__contents
        {
            width: 85%;
            margin: auto;
            margin-top: 6em;
            letter-spacing: 0.1em;

            @media screen and (min-width: 500px)
            {
                max-width: 110em;
            }
        }

        .cnnix__footer__title
        {
            font-weight: bold;
            font-size: 2.6em;
            letter-spacing: 0.1em;
            line-height: 2.4em;
        }

        .cnnix__footer__related-stories
        {
            @media print
            {
                display: none;
            }

            display: table;
            width: 100%;
            border-top: 1px solid #E6E6E6;
            border-bottom: 1px solid #E6E6E6;
            -webkit-padding-start: 0;

            li
            {
                display: block;
                width: 100%;

                @media screen and (min-width: 500px)
                {
                    display: table-cell;
                    width: 30%;
                    padding: 1em;
                }

                h1
                {
                    padding: 0.5em;
                    background-color: #E6E6E6;
                    color: #262626;
                    font-size: 2em;
                }

                img
                {
                    max-width: 100%;
                }

                p
                {
                    font-weight: 200;
                    font-size: 1.8em;
                }
            }
        }

        .cnnix__footer__credits
        {
            display: block;
            font-size: 1.8em;
            line-height: 2.4em;

            dt
            {
                font-weight: bold;
            }

            dd
            {
                font-weight: 300;
            }
        }

        .cnnix__footer__copyright
        {
            font-size: 1.3em;
        }

        .cnnix__footer__legal__list
        {
            list-style-type: none;
            -webkit-margin-after: 0;
            -webkit-margin-start: 0;
            -webkit-margin-end: 0;
            -webkit-padding-start: 0;
        }

        .cnnix__footer__item
        {
            margin-right: 1.6em;
            padding-right: 1.6em;
            text-transform: uppercase;

            @media screen and (min-width: 500px)
            {
                display: inline;
                width: 100%;
            }
        }

        .cnnix__footer__logo
        {
            display: block;
            width: 5em;
            height: 5em;
            margin-left: 90%;

            @media screen and (min-width: 740px)
            {
                float: right;
            }
        }
    `;
